import { createStore, createEvent } from 'effector';
import { setLocaleWeight, LOCALE, localeWeightMap } from '@stores/localeWeight';

// localeWeightSpamUsers store is used for setting locale default filter to 'all' in spam user list page.
// Using the store is necessary to avoid changing localeWeight to 'all' when user doesn't event do this manually (vie user interface).
const localeWeightSpamUsers = createStore<LOCALE>(LOCALE.ALL);

const setLocaleWeightSpamUsers = createEvent<LOCALE>('Select Locale Weight Spam Users');
const resetLocaleWeightSpamUsers = createEvent('Reset Locale Weight Spam Users');

const handleEventSetLocaleWeightSpamUsers = (state: LOCALE, localeName: LOCALE) => {
  setLocaleWeight(localeName);
  return localeName;
};

localeWeightSpamUsers
  .on(setLocaleWeightSpamUsers, handleEventSetLocaleWeightSpamUsers)
  .reset(resetLocaleWeightSpamUsers);

export { setLocaleWeightSpamUsers, resetLocaleWeightSpamUsers, LOCALE, localeWeightMap };
export default localeWeightSpamUsers;
